export interface ConfigState {
  readonly loading: boolean;
  readonly data?: any;
  readonly errors?: string;
  readonly messageConfig?: MessageConfig;
}

export interface MessageConfig {
  messages: Message[],
  loading: boolean
}

export interface Message {
  route: string;
  messageText: string;
  expirationDate: Date;
  isDismissable: boolean;
}

export enum ConfigActionsTypes {
  CONFIG_MESSAGESCONFIGURATION_REQUEST = '@@config/LPX_MESSAGESCONFIGURATION_REQUEST',
  CONFIG_MESSAGESCONFIGURATION_SUCCESS = '@@config/LPX_MESSAGESCONFIGURATION_SUCCESS',
  CONFIG_MESSAGESCONFIGURATION_ERROR = '@@config/LPX_MESSAGESCONFIGURATION_ERROR',
}